import { useQuery } from "@tanstack/react-query";
import i18n from "i18n";
import { AIModelProvider } from "@graylog/enterprise-api";
import { defaultOnError } from "util/conditional/onError";
const useModelProviders = () => {
  const { data, isLoading } = useQuery({
    queryKey: ["ai-model-providers"],
    queryFn: () => defaultOnError(
      AIModelProvider.providers(),
      i18n.t("notifications.model_providers_load_message", { ns: "enterprise_ai" }),
      i18n.t("notifications.model_providers_load_title", { ns: "enterprise_ai" })
    )
  });
  return { data: data != null ? data : [], isLoading };
};
export default useModelProviders;
